import api from '@/api'

const namespaced = true

const state = {
  fleetRequirements: {},
  fleetRequirementFiles: {}
}

const getters = {
  fleetRequirements: state => state.fleetRequirements,
  fleetRequirementFiles: state => state.fleetRequirementFiles
}

const mutations = {
  SET_FLEET_REQUIREMENTS: (state, payload) => {
    state.fleetRequirements = payload
  },
  SET_FLEET_REQUIREMENT_FILES: (state, payload) => {
    state.fleetRequirementFiles = payload
  }
}

const actions = {
  async fetchFleetRequirements({ commit }) {
    try {
      const { data } = await api.getFleetRequirements()
      if (!data.error) {
        commit('SET_FLEET_REQUIREMENTS', data)
      }
    } catch (err) {
      throw err
    }
  },
  async downloadFleetRequirements({ commit }) {
    try {
      const response = await api.downloadFleetRequirements()
      if (response) {
        commit('SET_FLEET_REQUIREMENT_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetFleetRequirements({ commit }) {
    commit('SET_FLEET_REQUIREMENT_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }
